import { createIcon } from "@chakra-ui/react";

export const HalfCircle = createIcon({
  displayName: "HalfCircle",
  viewBox: "0 0 72 72",
  path: [
    <mask
      id="x4r5ie2zya"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="73"
      height="72"
    >
      <path fill="#D9D9D9" d="M.864 0h72v72h-72z" />
    </mask>,
    <g mask="url(#x4r5ie2zya)">
      <path
        d="m70.543 41.267-3.117 5.234-3.837 4.743-4.513 4.176-5.517 2.712-5.676 2.323-6.114.404-6.085.472-5.974-1.288-5.657-2.234-5.128-3.22-5.075-3.433-4.113-4.604-2.882-5.461-1.853-5.853-.532-6.07-.725-6.096 1.907-5.84 1.621-5.369 5.14 2.388 5.419 2.172 5.073 2.903 5.621 1.743 5.171 2.697 5.386 2.242 4.834 3.407 5.663 1.655 5.146 2.75 5.247 2.536 5.2 2.635 5.37 2.276z"
        fill="currentColor"
      />
    </g>,
  ],
  defaultProps: {
    color: "#F7D44F",
  },
});

export default HalfCircle;
